var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M55.5 28C55.5 43.1878 43.1878 55.5 28 55.5C12.8122 55.5 0.5 43.1878 0.5 28C0.5 12.8122 12.8122 0.5 28 0.5C43.1878 0.5 55.5 12.8122 55.5 28ZM9.07497 28C9.07497 38.452 17.548 46.925 28 46.925C38.452 46.925 46.925 38.452 46.925 28C46.925 17.548 38.452 9.07497 28 9.07497C17.548 9.07497 9.07497 17.548 9.07497 28Z",
    fill: "#7745E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2125 28C53.5804 28 55.5341 26.069 55.1664 23.7298C54.8298 21.588 54.2402 19.4885 53.4067 17.4762C52.0247 14.1398 49.999 11.1082 47.4454 8.55456C44.8918 6.00095 41.8602 3.97532 38.5238 2.59331C36.5115 1.75977 34.412 1.17022 32.2702 0.833555C29.931 0.465867 28 2.41957 28 4.78748C28 7.15539 29.9435 9.02669 32.2509 9.55856C33.2705 9.79357 34.2711 10.1133 35.2423 10.5155C37.5384 11.4666 39.6247 12.8606 41.382 14.618C43.1394 16.3753 44.5334 18.4616 45.4845 20.7577C45.8867 21.7289 46.2064 22.7295 46.4414 23.7491C46.9733 26.0565 48.8446 28 51.2125 28Z",
    fill: "#7745E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.dff2551cee9a25527567104b8aee90f6.svg";
export { ForwardRef as ReactComponent };